import { z } from 'zod';
/**
 * Идентификатор единицы контента (rules-engine.md, раздел 4).
 *
 * Ровно две формы, третьей нет:
 *
 * - `srd:<ключ>` — контент из SRD 5.2, без владельца (D7);
 * - `u:<владелец>:<ключ>` — пользовательский контент.
 *
 * Форма проверяется схемой, а не соглашением: идентификатор попадает
 * в условия эффектов и в провенанс, и опечатка в нём означает эффект,
 * который молча не применится.
 */
export const contentIdSchema = z
    .string()
    .regex(/^(srd:[a-z0-9_]+|u:[a-z0-9_]+:[a-z0-9_]+)$/, 'ожидается srd:<ключ> или u:<владелец>:<ключ>');
/**
 * Путь к величине листа или к полю контекста расчёта: `ac`,
 * `saves.wis`, `abilities.dex.mod`, `state.equipped`.
 *
 * Схема проверяет только форму пути. Существование пути проверяет
 * движок при чтении контекста: путь вне контекста — ошибка расчёта,
 * а не `undefined` (rules-engine.md, раздел 4).
 */
export const pathSchema = z.string().regex(
// Сегмент начинается со строчной буквы; дальше допускается
// camelCase — поля контекста расчёта именуются так же, как в коде
// (`state.activeEffects`), и переименовывать их ради регулярного
// выражения значило бы подгонять данные под проверку.
/^[a-z][A-Za-z0-9_]*(\.[a-z][A-Za-z0-9_]*)*$/, 'ожидается путь вида ac, saves.wis или state.activeEffects');
/**
 * Ключ признака (D21.3): владение, сопротивление, преимущество,
 * помеха, состояние. Форма та же, что у пути, — точки разделяют
 * уточнения: `poison`, `skill.athletics`, `save.poisoned`.
 *
 * Признак — не путь к величине: он лежит *внутри* набора, а набор
 * адресуется путём (`resistances`, `proficiencies`).
 */
export const traitKeySchema = z
    .string()
    .regex(/^[a-z][A-Za-z0-9_]*(\.[a-z][A-Za-z0-9_]*)*$/, 'ожидается ключ признака вида poison или skill.athletics');
//# sourceMappingURL=content-id.js.map